import { useState, useEffect } from "react";
import api from "../Api";

export function useCustomerList() {
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchCustomers();
    }, []);

    const fetchCustomers = async () => {
        setLoading(true);
        try {
            const response = await api.get("/customers");
            setCustomers(response.data);
        } catch (err) {
            setError("Fout bij laden van klanten.");
        } finally {
            setLoading(false);
        }
    };

    const deleteCustomer = async (id) => {
        try {
            await api.delete(`/customers/${id}`);
            setCustomers((prev) => prev.filter((c) => c.id !== id));
        } catch (err) {
            // Check if it's a conflict error (customer has projects)
            if (err.response && err.response.status === 409) {
                throw new Error("Deze klant kan niet worden verwijderd omdat er nog projecten aan gekoppeld zijn.");
            }
            // Re-throw other errors
            throw err;
        }
    };

    const createCustomer = async (customerData) => {
        const response = await api.post("/customers", customerData);
        setCustomers((prev) => [...prev, response.data]);
        return response.data;
    };

    return {
        customers,
        loading,
        error,
        fetchCustomers,
        deleteCustomer,
        createCustomer
    };
}
